import Vue from "vue";
import axios from "axios";
import debounce from "lodash.debounce";

export default {
  name: "MetersDataGrid",
  components: {
    DataGridComp: require("@/customcontrols/datagrid.vue").default,
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
    SearchFields: require("./searchFields.vue").default,
  },
  props: {
    appKey: {
      type: Number,
      required: true,
    },
    appId: {
      type: String,
      required: true,
    },
    meterTypes: {
      type: Array,
      required: true,
    },
    preselectedMeters: {
      type: Array,
      default: () => [],
    },
    refName: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      metersList: [],
      cols: [],
      pagination: {
        pageSize: 10,
        page: 1,
        total: 0,
      },
    };
  },
  created() {
    this.debouncedFunc = debounce(() => this.getMetersFunc(), 3500);

    this.getMetersFunc();
    this.fillApplicationsColumns();
  },
  beforeUnmount() {
    this.debouncedFunc.cancel();
  },
  methods: {
    pageChange(pInfo) {
      if (
        this.pagination.page == pInfo.pageNumber &&
        this.pagination.pageSize == pInfo.pageSize
      )
        return;

      this.pagination.page = pInfo.pageNumber;
      this.pagination.pageSize = pInfo.pageSize;
      this.getMetersFunc();
    },
    getMetersFunc(search) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      const parameters = {
        ...search,
        ActivityParameters: {
          ApplicationKey: this.appKey,
          ApplicationId: this.appId,
        },
        Options: this.pagination,
      };

      axios
        .post("/ReserveMetersActivity/GetMetersToSelect", parameters)
        .then((response) => {
          response.data.metersToSelect.forEach(
            (meter) => (meter["toImport"] = false)
          );

          this.preselectedMeters.forEach((pre) => {
            if (pre.isSelected) {
              const found = response.data.metersToSelect.find(
                (m) => m.id === pre.id
              );
              if (found) {
                found.toImport = true;
              }
            }
          });

          this.metersList.length = 0;
          this.metersList = response.data.metersToSelect;

          this.pagination.total = response.data.totalPages;
        })
        .catch((e) => {
          console.log("err", e);
        })
        .finally(() => loader.hide());
    },

    fillApplicationsColumns() {
      this.cols = [];

      this.cols.push({
        dataField: "toImport",
        name: "toImport",
        caption: "", //this.$t("ReserveMeter.ToImport"),
        width: 100,
      });

      this.cols.push({
        dataField: "typeId",
        name: "type",
        caption: this.$t("sendEmail.type"),
        width: 150,
      });

      this.cols.push({
        dataField: "displayString",
        name: "reference",
        caption: this.$t("customReadings.Reference"),
      });

      this.cols.push({
        dataField: "serialNo",
        name: "serialNo",
        caption: this.$t("disconnections.MeterSerialNo"),
        dataType: "date",
      });

      this.cols.push({
        dataField: "size",
        name: "size",
        caption: this.$t("activities.size"),
        dataType: "string",

        width: 100,
      });
    },
    onCellClick(item) {
      if (!item.data) return;

      let isImport = false;
      for (let i = 0; i < this.metersList.length; i++) {
        if (this.metersList[i].id == item.data.id) {
          Vue.set(this.metersList[i], "toImport", !this.metersList[i].toImport);
          isImport = this.metersList[i].toImport;
          break;
        }
      }

      this.$oldAlertMsg(
        isImport
          ? this.$t("ReserveMeter.MeterSelected")
          : this.$t("ReserveMeter.MeterDeselected"),
        1
      );

      this.$emit(
        "onMetersSelected",
        this.metersList.filter((m) => m.toImport)
      );
    },
    onRowDbClick(item) {
      this.$emit("rowDbClick", item.data);
    },
  },
};
